const bardata = [
    {
        "country": "AD",
        "hot dog": 189,
        "hot dogColor": "hsl(163, 70%, 50%)",
        "burger": 18,
        "burgerColor": "hsl(72, 70%, 50%)",
        "sandwich": 107,
        "sandwichColor": "hsl(199, 70%, 50%)",
        "kebab": 90,
        "kebabColor": "hsl(197, 70%, 50%)",
        "fries": 91,
        "friesColor": "hsl(116, 70%, 50%)",
        "donut": 154,
        "donutColor": "hsl(171, 70%, 50%)"
    },
    {
        "country": "AE",
        "hot dog": 139,
        "hot dogColor": "hsl(297, 70%, 50%)",
        "burger": 123,
        "burgerColor": "hsl(235, 70%, 50%)",
        "sandwich": 128,
        "sandwichColor": "hsl(17, 70%, 50%)",
        "kebab": 154,
        "kebabColor": "hsl(262, 70%, 50%)",
        "fries": 64,
        "friesColor": "hsl(213, 70%, 50%)",
        "donut": 164,
        "donutColor": "hsl(198, 70%, 50%)"
    },
    {
        "country": "AF",
        "hot dog": 15,
        "hot dogColor": "hsl(72, 70%, 50%)",
        "burger": 1,
        "burgerColor": "hsl(119, 70%, 50%)",
        "sandwich": 21,
        "sandwichColor": "hsl(128, 70%, 50%)",
        "kebab": 59,
        "kebabColor": "hsl(297, 70%, 50%)",
        "fries": 92,
        "friesColor": "hsl(159, 70%, 50%)",
        "donut": 109,
        "donutColor": "hsl(228, 70%, 50%)"
    },
    {
        "country": "AG",
        "hot dog": 175,
        "hot dogColor": "hsl(66, 70%, 50%)",
        "burger": 62,
        "burgerColor": "hsl(106, 70%, 50%)",
        "sandwich": 103,
        "sandwichColor": "hsl(90, 70%, 50%)",
        "kebab": 190,
        "kebabColor": "hsl(237, 70%, 50%)",
        "fries": 39,
        "friesColor": "hsl(272, 70%, 50%)",
        "donut": 172,
        "donutColor": "hsl(189, 70%, 50%)"
    },
    {
        "country": "AI",
        "hot dog": 89,
        "hot dogColor": "hsl(325, 70%, 50%)",
        "burger": 101,
        "burgerColor": "hsl(78, 70%, 50%)",
        "sandwich": 42,
        "sandwichColor": "hsl(265, 70%, 50%)",
        "kebab": 132,
        "kebabColor": "hsl(293, 70%, 50%)",
        "fries": 186,
        "friesColor": "hsl(66, 70%, 50%)",
        "donut": 16,
        "donutColor": "hsl(200, 70%, 50%)"
    },
    {
        "country": "AL",
        "hot dog": 33,
        "hot dogColor": "hsl(278, 70%, 50%)",
        "burger": 68,
        "burgerColor": "hsl(117, 70%, 50%)",
        "sandwich": 188,
        "sandwichColor": "hsl(265, 70%, 50%)",
        "kebab": 66,
        "kebabColor": "hsl(135, 70%, 50%)",
        "fries": 110,
        "friesColor": "hsl(244, 70%, 50%)",
        "donut": 188,
        "donutColor": "hsl(242, 70%, 50%)"
    },
    {
        "country": "AM",
        "hot dog": 94,
        "hot dogColor": "hsl(36, 70%, 50%)",
        "burger": 108,
        "burgerColor": "hsl(257, 70%, 50%)",
        "sandwich": 196,
        "sandwichColor": "hsl(276, 70%, 50%)",
        "kebab": 9,
        "kebabColor": "hsl(25, 70%, 50%)",
        "fries": 16,
        "friesColor": "hsl(356, 70%, 50%)",
        "donut": 91,
        "donutColor": "hsl(293, 70%, 50%)"
    }
]
export default bardata;